import React from "react";

class Speaker2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "Keynote Speakers - 21st International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Keynote Speaker</h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <div className="col-xl-12 col-md-12">
                      <img
                        src={require("../assets/img-comm/maria2.png")}
                        alt=""
                        width="230"
                        height="270"
                      />
                      <h4>Dr Maria José Sousa</h4>

                      <div className="organiser_intro mt-2 col-md-12">
                        <div className="col-md-12">
                          <p align="center">
                            <i>
                              Professor and Senior Researcher at ISCTE –
                              University Institute of Lisbon
                            </i>
                          </p>
                        </div>
                      </div>
                      <br></br>
                      <div className="intro_left_content text_left">
                        <p align="left">
                          Maria José Sousa (PhD in Industrial Management, with
                          Habilitation in Management and Public Management) is a
                          professor and senior researcher at ISCTE – University
                          Institute of Lisbon. She served as Pro-Rector at Iscte
                          and was a member of the scientific committee of the
                          PhD in Law and Economics (Cycle XXXIX) at the
                          University of Molise. She was also a member of the
                          Advisory Board of Banco Português de Fomento in the
                          area of Public Policies (2024–2026). She held a
                          postdoctoral position from 2016 to 2018, researching
                          digital education, with several publications in
                          high-impact journals (Journal of Business Research,
                          Journal of Grid Computing, Future Generation Computer
                          Systems, among others). She worked as an expert on a
                          European Commission project to create a new category
                          of digital skills to be included in the European
                          Innovation Scoreboard (EIS).
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Speaker2;
